import Cadastro from './services/Cadastro'
import Conciliacao from './services/Conciliacao'
import Corporativo from './services/Corporativo'
import LocaisExecucao from './services/LocaisExecucao'
import Medicos from './services/Medicos'
import Negociacao from './services/Negociacao'
import Operadora from './services/Operadora'
import Procedimentos from './services/Procedimentos'
import Recebimento from './services/Recebimento'
import TabelasTuss from './services/TabelasTuss'

export default {
  Cadastro,
  Conciliacao,
  Corporativo,
  LocaisExecucao,
  Medicos,
  Negociacao,
  Operadora,
  Procedimentos,
  Recebimento,
  TabelasTuss,
}



